import { __decorate } from "tslib";
import Money from "@/components/Money.vue";
import PrettyBytes from "@/filters/pretty-bytes";
import { Vue, Component, Prop } from "vue-property-decorator";
import Percent from "@/components/Percent.vue";
let ReportCard = class ReportCard extends Vue {
    value;
    percent;
    percentTooltip;
    icon;
    label;
    money;
    bytes;
    prettyBytes(value) {
        return PrettyBytes(value || 0);
    }
};
__decorate([
    Prop()
], ReportCard.prototype, "value", void 0);
__decorate([
    Prop()
], ReportCard.prototype, "percent", void 0);
__decorate([
    Prop({ type: String, default: '' })
], ReportCard.prototype, "percentTooltip", void 0);
__decorate([
    Prop(String)
], ReportCard.prototype, "icon", void 0);
__decorate([
    Prop(String)
], ReportCard.prototype, "label", void 0);
__decorate([
    Prop(Boolean)
], ReportCard.prototype, "money", void 0);
__decorate([
    Prop(Boolean)
], ReportCard.prototype, "bytes", void 0);
ReportCard = __decorate([
    Component({
        components: {
            Percent,
            Money
        },
    })
], ReportCard);
export default ReportCard;
;
